<template>
  <div v-if="loading">
    Loading all projects from store...
  </div>
  <div v-else>
    <div class="debug">
      <p>checkedStatus = {{ checkedStatus }}</p>
      <!--p>allProjects.length = {{ allProjects.length }}</p-->
      <p>projectsTableData.length = {{ projectsTableData.length }}</p>
      <p>first entry = {{ projectsTableData[0] }}</p>
    </div>
  <FilterTable v-if="projectsTableData.length>0"
    :header="header"
    :data="projectsTableData"
    :columnWidths="colWidths"

    @rowClicked="printRow"
    v-model:filtered="filtered"
    v-model:search="search"
  >
    <template v-slot:header>
      <th v-for="(field, key) in header" :key="key" :scope="'col'">
        <ColumnFilter
          v-if="field != 'status'"
          v-model:searchText="search[field]"
          :column-name="field"
          @sortAsc="sortAscending"
          @sortDesc="sortDescending"
        ></ColumnFilter>
        <div v-else class="status-header">
          <span class="status-label">status:</span>          
          <div class="status-checkbox-div">
            <ProjectStatus v-model:projectStatus="checkedStatus" :detailed_view="false"></ProjectStatus>
            <!--CheckboxGroup
              :options="Object.keys(Status)"
              v-model:checked="checkedStatus"
            ></CheckboxGroup-->
          </div>    
        </div>
      </th>
    </template>
  </FilterTable>

  <!--div class="btn-row-left">
    <FormBtn v-if="currentGroup === 'admin'" :name="'Download all Projects Data'" @clicked="downloadAllProjects"></FormBtn>
     <FormBtn :name="'Refresh Table'" @clicked="forceFetchProjects"></FormBtn>
  </div-->
  </div>


   <!--     <p>header = {{ header }}</p>
        <p class="debug">checkedStatus= {{ checkedStatus }}</p>
        <p>allProjects.length = {{ allProjects.length }}</p>
        <p>colWidths = {{ colWidths }}</p>
        <p>filtered.length = {{ filtered.length }}</p>
        <p>search = {{ search }}</p>
    </div>-->
</template>

<script setup lang="ts">
/**
 * This is an async vue component which can work with Suspense in parent
 */

import { ref, watch, computed } from 'vue'
import { useProjectStore, useUserStore } from '@/stores'
import { type Project, projectSchema, Status } from '@/types/types'
import router from '@/router'
import { FilterTable } from '@/components/table'
import ColumnFilter from '@/components/table/Column-filter.vue'
import { useProjectTableFilter } from '@/composables/Project-table-filter'
import { useTableSorter } from '@/composables/Table-sorter'
import ProjectStatus from '@/components/Project-status.vue'
import { useAllCsvDownload } from '@/composables/All-csv-download'
//import { useProjectStatusFilter } from '@/composables/Project-status-filter';
import { CheckboxGroup, FormBtn } from '@/components/form'
import { storeToRefs } from 'pinia'


const projects = useProjectStore()
const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
//const allProjects = ref<Array<Project>>([])
//const { allProjects } = storeToRefs(projects);
//const { tableData } = storeToRefs(projects);
const projectsTableData = ref([]);
/*const projectsTableData = computed(()=>{
  return JSON.parse(JSON.stringify(tableData.value));
})*/

const header = [
  'id',
  'streetAddress',
  'city',
  'province',
  'customer',
  'status',
  'owner',
  'engineer',
  'drafter',
  'division'
]
const colWidths = [5, 18, 10, 5, 15, 15]

//await fetchProjects()
const loading = computed(()=>{
  return projects.loading;
})


//onBeforeMount(async ()=>{
  projectsTableData.value = await projects.fetchTableData();
//})

let searchJson = {}
header?.forEach((col) => {
  searchJson[col] = ''
})
const search = ref(searchJson)
//check them all to start, TODO add blanks?
//const checkedStatus = ref(Object.keys(Status))
const checkedStatus = ref([]);
//checkedStatus.value.push('EMPTY');
search.value.status = checkedStatus.value

//watch checked status

watch(
  () => checkedStatus.value,
  (newVal, oldVal) => {
    search.value.status = newVal //.join();
  },
  { deep: true }
)

//const filtered = ref(allProjects.value);
const { filtered } = useProjectTableFilter(projectsTableData, search)
const { sortAscending, sortDescending } = useTableSorter(filtered)

function printRow(item: Project) {
  console.log('printRow..')
  console.log(JSON.stringify(item))
  console.log('...pushing router to project_details')
  router.push(`/projects/${item.id.toString()}/details`)
}
</script>

<style lang="css" scoped>
span.status-label {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: white;
  /* width: auto;
    flex: auto;*/
}

.status-header {
  max-height: 10rem;
}
.status-checkbox-div {
  height: 8rem;
}
/*
th td head{
  max-height: 6rem;
}*/
</style>
